import React, { Fragment } from "react";
import PreParser from "../components/preParser";
import Content from "../components/blocks/gco/content";
import Layout from "../components/layout/layout";
import HTMLParser from "../components/htmlParser";
import decodeHTMLEntities from "../utils/decodeHTMLentities";
import fixCategories from "../utils/fixCategories";
import { Link } from "gatsby";
const Entry = (props) => {
    if (props.excludeLocalSearch)
        return React.createElement(React.Fragment, null);
    const Tag = parseInt(props.level) <= 6 ? "h" + props.level : "p";
    if (!props.uri) {
        return (React.createElement("li", null,
            React.createElement(Tag, null,
                React.createElement(HTMLParser, null, props.title)),
            props.description && props.description.length ? (React.createElement("p", { className: "description" },
                React.createElement(HTMLParser, null, props.description))) : (React.createElement(React.Fragment, null)),
            props.children));
    }
    return (React.createElement("li", null,
        React.createElement(Tag, null,
            React.createElement(Link, { to: props.uri, title: decodeHTMLEntities(props.linkTitle) },
                React.createElement(HTMLParser, null, props.title)),
            props.description && props.description.length ? (React.createElement("p", { className: "description" },
                React.createElement(HTMLParser, null, props.description))) : (React.createElement(React.Fragment, null))),
        props.children));
};
const Sitemap = ({ data }) => {
    const flatten = (structure) => {
        const output = [];
        structure.forEach((block) => {
            if (block.innerBlocks?.length) {
                output.push(...block.innerBlocks);
                delete block.innerBlocks;
            }
            output.push(block);
        });
        return output;
    };
    const extractTitles = (structure) => {
        if (typeof structure === "string" && structure.length) {
            try {
                structure = JSON.parse(structure);
            }
            catch {
                return [];
            }
        }
        structure = flatten(structure);
        const titles = structure
            .filter((block) => block.name === "core/heading")
            .map((block) => {
            const title = {
                value: block.attributes.content,
                level: block.attributes.level || 2,
            };
            if (block.id) {
                title.id = block.id;
            }
            return title;
        })
            .filter((e) => e.value !== undefined);
        return titles;
    };
    const walkPages = (pages, parents, level) => {
        return pages
            .sort((a, b) => {
            return a.title.localeCompare(b.title);
        })
            .map((page) => {
            const titles = extractTitles(page.jsonContent);
            const children = data.allWpPage.nodes.filter((child) => child.wpParent && child.wpParent.node.slug === page.slug);
            const uri = "/" + [...parents, page.slug].join("/") + "/";
            return (React.createElement(React.Fragment, null,
                React.createElement(Entry, { uri: uri, title: page.seo?.openGraphTitle || page.title, description: page.seo?.description, excludeLocalSearch: page.seo?.excludeLocalSearch, level: level, linkTitle: "Visiter la page " + page.title },
                    React.createElement("ul", { className: "is-titles" }, titles.map((e) => {
                        return (React.createElement(Entry, { uri: e.id ? uri + "#" + e.id : false, title: e.value, linkTitle: "Consulter la section " +
                                e.value +
                                " de la page " +
                                page.title, level: level + e.level }));
                    })),
                    React.createElement("ul", null, children.length ? (walkPages(children, [...parents, page.slug], level + 1)) : (React.createElement(React.Fragment, null))))));
        });
    };
    const walkPosts = (categories, level) => {
        if (!categories) {
            return React.createElement(React.Fragment, null);
        }
        return categories
            .sort((a, b) => {
            return a.name.localeCompare(b.name);
        })
            .map((cat) => {
            if (!(cat.children && cat.children.length) &&
                !data.allWpPost.edges.filter((e) => e.node.categories.nodes.some((postCategory) => postCategory.slug === cat.slug))?.length) {
                return React.createElement(Fragment, { key: cat.slug });
            }
            return (React.createElement(Fragment, { key: cat.slug },
                React.createElement(Entry, { uri: cat.realUri, title: cat.seo?.openGraphTitle || cat.name, description: cat.seo?.description || cat.description, level: level, linkTitle: "Découvrir les dernières actualités de la catégorie " + cat.name },
                    React.createElement("ul", null, data.allWpPost.edges
                        .filter((e) => e.node.categories.nodes.some((postCategory) => postCategory.slug === cat.slug))
                        .map((e) => {
                        const titles = extractTitles(e.node.jsonContent);
                        return (React.createElement(React.Fragment, null,
                            React.createElement(Entry, { uri: e.node.realUri, title: e.node.seo?.openGraphTitle || e.node.title, description: e.node.seo?.description, excludeLocalSearch: e.node.seo?.excludeLocalSearch, level: level + 1, linkTitle: "Consulter l'actualité " + e.node.title },
                                React.createElement("ul", { className: "is-titles" }, titles.map((title) => {
                                    return (React.createElement(Entry, { uri: title.id
                                            ? e.node.realUri + "#" + e.id
                                            : false, title: title.value, linkTitle: "Consulter la section \"" +
                                            title.value +
                                            "\" de l'actualité \"" +
                                            e.node.title +
                                            "\"", level: level + 1 + title.level }));
                                })))));
                    })),
                    React.createElement("ul", null, walkPosts(cat.children, level + 1)))));
        });
    };
    const template = data.sitemap;
    const homeTitles = extractTitles(data.home.jsonContent);
    const searchTitles = extractTitles(data.search.jsonContent);
    const fixedCategories = fixCategories(data.allWpCategory.nodes);
    const SiteMapContent = () => (React.createElement("section", { id: "sitemap" },
        React.createElement("ul", { className: "is-style-list-no-disc" },
            React.createElement(Entry, { uri: "/", title: data.home.seo?.openGraphTitle || data.home.title, description: data.home.seo?.description, excludeLocalSearch: data.home.seo?.excludeLocalSearch, level: 2, linkTitle: "Retourner \u00E0 la page d'accueil" },
                React.createElement("ul", { className: "is-titles" }, homeTitles.map((e) => {
                    return (React.createElement(Entry, { uri: e.id ? "/#" + e.id : false, title: e.value, linkTitle: "Consulter la section \"" +
                            e.value +
                            "\" de la page d'accueil", level: 2 + e.level }));
                })),
                React.createElement("ul", null, walkPages(data.allWpPage.nodes.filter((page) => page.wpParent === null), [], 2))),
            React.createElement(Entry, { uri: "/" + data.news.slug + "/", title: data.news.seo?.openGraphTitle || data.news.title, description: data.news.seo?.description, excludeLocalSearch: data.news.seo?.excludeLocalSearch, level: 2, linkTitle: "D\u00E9couvrir les derni\u00E8res actualit\u00E9s" },
                React.createElement("ul", null, walkPosts(fixedCategories, 3))),
            React.createElement(Entry, { uri: "/" + data.search.slug + "/", title: data.search.seo?.openGraphTitle || data.search.title, description: data.search.seo?.description, excludeLocalSearch: data.search.seo?.excludeLocalSearch, level: 2, linkTitle: "Visiter cette page pour effectuer une recherche sur le site" },
                React.createElement("ul", { className: "is-titles" }, searchTitles.map((e) => {
                    return (React.createElement(Entry, { uri: e.id ? "/" + data.search.slug + "/#" + e.id : false, title: e.value, linkTitle: "Consulter la section \"" +
                            e.value +
                            "\" de la page de recherche", level: 2 + e.level }));
                }))))));
    return (React.createElement(Layout, { infos: { title: template.title }, seo: template.seo, data: data },
        React.createElement(PreParser, { structure: template.jsonContent },
            React.createElement(Content, null,
                React.createElement(SiteMapContent, null)),
            React.createElement(React.Fragment, null))));
};
export default Sitemap;
